import {
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
  createTheme,
  colors,
} from '@mui/material';
import { deDE, enUS } from '@mui/material/locale';
import { deDE as gridDeDE, enUS as gridEnUS } from '@mui/x-data-grid-premium/locales';
import { QueryClientProvider } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SnackbarProvider } from 'notistack';
import AuthProvider from 'react-auth-kit';
import { RouterProvider } from 'react-router-dom';
import { useCreateQueryClient } from './query-client';
import router from './router';
import { store } from './store';
import { DialogsProvider } from '@components/dialogs/dialogs-provider';

export function Providers() {
  const queryClient = useCreateQueryClient();
  const { i18n } = useTranslation();

  // Create theme dynamically based on current language
  const theme = useMemo(() => {
    const muiLocale = i18n.language === 'de' ? deDE : enUS;
    const gridLocale = i18n.language === 'de' ? gridDeDE : gridEnUS;

    return createTheme(
      {
        palette: {
          primary: {
            main: '#02344C',
          },
          secondary: {
            main: '#ffc107',
          },
          background: {
            default: colors.grey[100],
          },
        },
        breakpoints: {
          values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
          },
        },
        components: {
          MuiPopover: {
            defaultProps: {
              container: document.getElementById('root'),
            },
          },
          MuiPopper: {
            defaultProps: {
              container: document.getElementById('root'),
            },
          },
        },
      },
      muiLocale,
      gridLocale,
    );
  }, [i18n.language]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider store={store}>
          <QueryClientProvider client={queryClient}>
            <SnackbarProvider maxSnack={3}>
              <DialogsProvider>
                <RouterProvider router={router} />
              </DialogsProvider>
            </SnackbarProvider>
          </QueryClientProvider>
        </AuthProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
